__turbopack_context__.v({
  "thumbnail": "NJa8MG_thumbnail",
  "videocontainer": "NJa8MG_videocontainer",
  "videoinnercontainer": "NJa8MG_videoinnercontainer",
});
